import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Bar } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

import { StyledChart } from './styles/StyledChart';


// bar for testing colors
/*
  <div style={{height: 50, width: 200, margin: 20, border: '1px solid rgba(255,99,132,1)', backgroundColor: 'rgba(255,99,132,0.2)'}}>
  </div>
*/


class Chart extends Component {
  render() {
    const { data, yMax, selected, labels, formatter, } = this.props;

    return (
      <StyledChart>
        <Bar
          width={300}
          height={100}
          data={{
            labels: labels,
            datasets: [
              {
                backgroundColor: selected ? 'rgba(255, 158, 44, 0.6)' : 'rgba(37, 94, 216, 0.6)',
                borderColor: selected ? 'rgb(255, 163, 33)' : 'rgb(33, 72, 126)',
                borderWidth: 1,
                hoverBackgroundColor: selected ? 'rgba(255, 158, 44, 0.8)' : 'rgba(37, 94, 216, 0.8)',
                hoverBorderColor: selected ? 'rgb(255, 163, 33)' : 'rgb(33, 72, 126)',
                data: data,
                datalabels: {
                  align: 'end',
                  anchor: 'end',
                  padding: 0,
                  formatter: formatter,
                },
              }
            ]
          }}
          options={{
            layout: {
              padding: {
                left: 0,
                right: 0,
                top: 20,
                bottom: 0
              }
            },
            tooltips: {
              enabled: false,
            },
            legend: {
              display: false,
            },
            responsive: true,
            maintainAspectRatio: true,
            scales: {
              yAxes: [{
                display: false,
                ticks: {
                  max: yMax,
                  min: 0,
                  
                }
              }],
              xAxes: [{
                display: true,
                maxBarThickness: 90,
                drawTicks: false,
                gridLines: {
                  drawOnChartArea: false,
                },
              }]
           },
          }}
        />
      </StyledChart>
    );
  }
}


Chart.propTypes = {
  data: PropTypes.array,
  labels: PropTypes.array,
  yMax: PropTypes.number.isRequired,
  selected: PropTypes.bool.isRequired,
  formatter: PropTypes.func,
};


export default Chart;



// WEBPACK FOOTER //
// ./src/common/Chart/Chart.js